package sarka.design.skoria.ui.composables

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardColors
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.ui.tooling.preview.Preview
import sarka.design.skoria.ui.theme.RCTheme

@Composable
fun SkoriaSecondaryButton(
    modifier: Modifier = Modifier,
    text: String,
    onClick: () -> Unit,
) {
    Card(
        onClick = { onClick() },
        shape = RoundedCornerShape(12.dp),
        border = BorderStroke(1.dp, RCTheme.colors.onSurfaceVariant),
        colors = CardColors(
            containerColor = RCTheme.colors.secondaryContainer,
            contentColor = RCTheme.colors.onSurface,
            disabledContainerColor = Color.Transparent,
            disabledContentColor = Color.Transparent
        ),
    ) {
        Column(
            modifier = modifier
                .padding(vertical = 8.dp, horizontal = 16.dp)
                .widthIn(min = 96.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(text = text)
        }
    }
}

@Composable
@Preview
fun SkoriaSecondaryButtonPreview() {
    RCTheme {
        SkoriaSecondaryButton(
            text = "Login",
            onClick = {}
        )
    }
}